import { applyRoleFilter } from 'dashboard/store/modules/conversations/helpers';
import {
  getUserPermissions,
  getUserRole,
} from 'dashboard/helper/permissionsHelper';

export const isConversationAccessible = (app, conversation) => {
  if (!conversation) return false;

  const store = app.$store;
  const currentUser = store.getters.getCurrentUser;
  const currentAccountId = store.getters.getCurrentAccountId;
  const currentUserId = store.getters.getCurrentUserID;
  const permissions = getUserPermissions(currentUser, currentAccountId);
  const userRole = getUserRole(currentUser, currentAccountId);
  const userTeamIds =
    store.getters['teams/getMyTeams']?.map(team => team.id) || [];

  const conversationPayload = conversation.id
    ? conversation
    : { meta: {}, ...conversation };

  return applyRoleFilter(
    conversationPayload,
    userRole,
    permissions,
    currentUserId,
    userTeamIds
  );
};
